import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { DisplayModes } from '../../models/enums';
import { SalesFileService } from '../services/sales-file.service';
import { PlanStatus } from '../../plan/enums/plan-status.enum';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'crm-user-target-request',
  templateUrl: './user-target-request.component.html',
  styleUrls: ['./user-target-request.component.css']
})
export class UserTargetRequestComponent implements OnInit {

  addNew = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  displayMode: DisplayModes;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Representations.png");
  requests: any[] = [];
  selectedRequestId;
  viewMode = false;
  reviewMode = false;
  requestType;
  approvalLevels: any[] = [];
  currentUserId
  isBrandLevel = false;
  isParentOrgTypeLevel = false;
  isChildOrgTypeLevel = false;
  isHcoLevel = false;
  
  constructor(private translateService: AppTranslationService, private alertService: AlertService, private authService: AuthService, private readonly route: ActivatedRoute,
    private accountService: AccountService, private salesFileService: SalesFileService) { }

  ngOnInit() {
    this.currentUserId = this.authService.currentUser.id;
    this.getAll();
    this.getAllApprovalLevels();

    this.route.params.subscribe(params => {
      if (params["requestid"] && params["review"])
        this.review(params["requestid"])
      else if (params["requestid"] && params["complete"])
        this.complete(params["requestid"])
    });

  }

  getAllApprovalLevels() {
    this.salesFileService.getUserTargetRequestApprovalUsers()
      .subscribe(response => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.approvalLevels = response as any[];
        debugger;
        this.isBrandLevel = this.approvalLevels.some(x => x.type == 1 && x.usersIds.indexOf(Number(this.currentUserId)) > -1);
        this.isParentOrgTypeLevel = this.approvalLevels.some(x => x.type == 2 && x.usersIds.indexOf(Number(this.currentUserId)) > -1);
        this.isChildOrgTypeLevel = this.approvalLevels.some(x => x.type == 3 && x.usersIds.indexOf(Number(this.currentUserId)) > -1);
        this.isHcoLevel = this.approvalLevels.some(x => x.type == 4 && x.usersIds.indexOf(Number(this.currentUserId)) > -1);
        

      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  }

  getAll() {
    this.displayMode = DisplayModes.Loading;
    this.salesFileService.getUserTargetRequestsTree().subscribe(response => {
      this.requests = response as any[];
      this.pageSize = this.requests.length;
      this.displayMode = DisplayModes.Success;
    }, error => {
      this.displayMode = DisplayModes.Error;
    });
  }
  gotoNew() {
    this.handleRequestTypeBasedOnUserPermission();
    this.addNew = true;
  }

  view(requestId) {
    this.selectedRequestId = requestId;
    this.viewMode = true;
  }

  review(requestId) {
    this.selectedRequestId = requestId;
    this.reviewMode = true;
  }

  edit(requestId) {
    this.selectedRequestId = requestId;
    this.addNew = true;
  }


  closeAdding(event) {
    this.selectedRequestId = undefined;
    this.requestType = undefined;
    this.addNew = false;
    this.viewMode = false;
    this.reviewMode = false;
    if (event) {
      this.getAll();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  delete() {
    this.hideDeleteModal();
    this.salesFileService.deleteUserTargetRequest(this.selectedRequestId).subscribe(response => {
      if (response == false) {
        this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      }
      else {
        this.alertService.showMessage("", this.translateService.getTranslation("DeletedSuccessfully"), MessageSeverity.Success);
        this.getAll();
      }

    }, err => {

      this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);

    });
  }

  getStatusName(status: number): string {
    return PlanStatus[status];
  }

  getTypeName(type: number): string {
    if (type == 1)
      return "Brand"
    if (type == 2)
      return "Item and parent org type"
    if (type == 3)
      return "Item and child org type"
    if (type == 4)
      return "Item and Hco"
  }

  get canDeleteFile() {
    return this.accountService.userHasPermission(Permission.deleteUserTargetRequest);
  }

  canReviewRequest(type) {
    return (this.isBrandLevel && type == 2)
      || (this.isParentOrgTypeLevel && type == 3) ||
      (this.isChildOrgTypeLevel && type == 4);
  }

  canCompleteRequest(type) {
    // this.currentUserId==rrequesrt.userId
    return (this.isParentOrgTypeLevel && type == 2) ||
      (this.isChildOrgTypeLevel && type == 3) ||
      (this.isHcoLevel && type == 4);
  }

  canEditRequest(type, status) {
    return (this.isBrandLevel && type == 1 && status == 1) ||
      (this.isParentOrgTypeLevel && (type == 2 && (status == 4 || status == 1))) ||
      (this.isChildOrgTypeLevel && type == 3 && (status == 4 || status == 1)) ||
        (this.isHcoLevel && type == 4 && (status == 4 || status == 1));
  }

  confirmDeleteItem(requestId) {
    this.selectedRequestId = requestId;
    this.deleteModal.show();
  }

  handleRequestTypeBasedOnUserPermission() {
    if (this.isBrandLevel)
      this.requestType = 1;
    else if (this.isParentOrgTypeLevel)
      this.requestType = 2;
    else if (this.isChildOrgTypeLevel)
      this.requestType = 3;
    else if (this.isHcoLevel)
      this.requestType = 4;
  }

  complete(requestId) {
    this.selectedRequestId = requestId;
    this.addNew = true;
  }


}
